<template>
<Dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{$t(`type.${endpointType}`)}}</span>
  </template>

  <v-form ref="form" v-model="valid" lazy-validation class="py-2">
    <NameTextField v-model="name"></NameTextField>
    <ReportDifferenceTextField v-model="configurations.reportDifference" v-if="hasReportDifference"></ReportDifferenceTextField>
    <ReportDurationTextField v-model="configurations.reportDuration" v-if="hasReportDuration"></ReportDurationTextField>
    <ReportIntervalTextField v-model="configurations.reportInterval" v-if="hasReportInterval"></ReportIntervalTextField>
    <ReportSensitivityTextField v-model="configurations.reportSensitivity" v-if="hasReportSensitivity"></ReportSensitivityTextField>
    <ReportUnitSelector v-model="configurations.reportUnit" :units="rawAttributes.availableUnits" v-if="hasReportUnit"></ReportUnitSelector>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn outlined color="primary" :loading="submitting" :disabled="!canSubmit" @click="submit">{{ $t('submit') }}</v-btn>
  </template>

</Dialog>
</template>

<script>
import User from '@/components/auth/User'
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import ReportDifferenceTextField from '@/components/utils/ReportDifferenceTextField'
import ReportDurationTextField from '@/components/utils/ReportDurationTextField'
import ReportIntervalTextField from '@/components/utils/ReportIntervalTextField'
import ReportSensitivityTextField from '@/components/utils/ReportSensitivityTextField'
import ReportUnitSelector from '@/components/utils/ReportUnitSelector'

export default {
  name: 'EndpointSettingsDialog',
  mixins: [User, BaseDialog],
  components: {
    Dialog,
    NameTextField,
    ReportDifferenceTextField,
    ReportDurationTextField,
    ReportIntervalTextField,
    ReportSensitivityTextField,
    ReportUnitSelector
  },
  props: {
    device: {
      type: String,
      required: true
    },
    endpoint: {
      type: String
    }
  },
  data() {
    return {
      valid: false,
      submitting: false,
      name: null,
      configurations: {}
    }
  },
  watch: {
    rawName(val) {
      if (this.submitting) {
        if (val == this.name) {
          this.visible = false;
        }
      }
    },
    rawConfigurations(val) {
      if (this.submitting) {
        if (JSON.stringify(val) == JSON.stringify(this.configurations)) {
          this.visible = false;
        }
      }
    }
  },
  computed: {
    info() {
      return (this.userDevice[this.device] || {}).info || {};
    },
    config() {
      return (this.userDevice[this.device] || {}).config || {};
    },
    rawName() {
      return (this.config[this.endpoint] || {}).name;
    },
    isNameChanged() {
      return this.rawName != this.name;
    },
    isConfigurationsChanged() {
      return JSON.stringify(this.rawConfigurations) != JSON.stringify(this.configurations);
    },
    canSubmit() {
      return this.valid && (this.isNameChanged || this.isConfigurationsChanged);
    },
    endpointInfo() {
      return this.info.find(ep => ep.id == this.endpoint) || {};
    },
    endpointType() {
      return this.endpointInfo.type;
    },
    rawAttributes() {
      return this.endpointInfo.attributes || {};
    },
    rawConfigurations() {
      return this.endpointInfo.configurations || {};
    },
    hasReportInterval() {
      return this.rawConfigurations.hasOwnProperty('reportInterval');
    },
    hasReportDifference() {
      return this.rawConfigurations.hasOwnProperty('reportDifference');
    },
    hasReportUnit() {
      return this.rawConfigurations.hasOwnProperty('reportUnit');
    },
    hasReportSensitivity() {
      return this.rawConfigurations.hasOwnProperty('reportSensitivity');
    },
    hasReportDuration() {
      return this.rawConfigurations.hasOwnProperty('reportDuration');
    }
  },
  methods: {
    submit() {
      this.submitting = true;
      if (this.isNameChanged) this.configDevice({
        version: 1,
        timestamp: new Date().getTime(),
        device: {
          id: this.device
        },
        agent: {
          id: this.userId
        },
        endpoints: {
          [this.endpoint]: {
            name: this.name
          }
        }
      });
      if (this.isConfigurationsChanged) this.doCommand({
        version: 1,
        timestamp: new Date().getTime(),
        device: {
          id: this.device
        },
        agent: {
          id: this.userId
        },
        endpoints: {
          [this.endpoint]: {
            configurations: this.configurations
          }
        }
      }, 'command')
    }
  },
  mounted() {
    this.name = this.rawName;
    this.configurations = JSON.parse(JSON.stringify(this.rawConfigurations));
  }
}
</script>
